import type {
  ContractingDealFieldHistoryEntityType,
  ContractingFieldHistoryParams,
} from '~/types/services/contracting';

export const fieldHistoryQueryKeys = {
  all: ['contracting', 'field-history'] as const,
  opportunity: (
    opportunityId: string,
    entityType: ContractingDealFieldHistoryEntityType | undefined,
    params: ContractingFieldHistoryParams,
  ) => [...fieldHistoryQueryKeys.all, 'opportunity', opportunityId, entityType, params] as const,
  account: (accountId: string, params: ContractingFieldHistoryParams) =>
    [...fieldHistoryQueryKeys.all, 'account', accountId, params] as const,
  case: (caseNumber: string, params: ContractingFieldHistoryParams) =>
    [...fieldHistoryQueryKeys.all, 'case', caseNumber, params] as const,
};
